import React from "react";
import { useParams } from "react-router";
import { Container, Row, Col, Image, Button } from "react-bootstrap";

import {
	FaWhatsapp,
	FaMapMarkerAlt,
	FaAddressCard,
	FaMapMarkedAlt,
	FaPhoneAlt,
	FaEnvelope,
	FaUniversity,
	FaBalanceScale,
} from "react-icons/fa";
import logo_header from "./../assets/logos/logo-header.jpg";

const QRCodeCards = (props) => {
	const { profile_code } = useParams();

	const profiles = {
		"PR-JAZL": {
			name: "Lic. Jesús Alberto Zepeda Luna",
			from: "Egresado de la facultad de Derecho de la U.A.B.C.",
			speciality: "Derecho Fiscal, Derecho Administrativo",
			phone: [["686", "383", "8446"]],
			email: "",
		},
		"PR-CCR": {
			name: "Lic. Cuauhtemoc Cerda Ramos",
			from: "Egresado de la facultad de Derecho de la U.A.B.C., amplia experiencia como asesor jurídico y defensor",
			speciality: "Derecho Penal, Derecho Civil, Derecho Administrativo",
			phone: [["686", "177", "2489"]],
			email: "temo-hd@hotmail.com",
		},
		"PR-AQR": {
			name: "Lic. Arnoldo Quintero Robles",
			from: "Egresado de la facultad de Derecho de la U.A.B.C., amplia experiencia como asesor jurídico y defensor.",
			speciality: "Derecho Penal, Derecho Civil, Derecho Familiar",
			phone: [["686", "946", "2791"]],
			email: "lic.arnoldoquintero@hotmail.com",
		},
		"PR-BYQL": {
			name: "Lic. Brenda Y. Quintero López",
			from: "Asesor Jurídico",
			speciality: "Derecho Familiar, Derecho Mercantil, Propiedad Industrial",
			phone: [["686", "201", "7398"]],
			email: "brendayadiira@gmail.com",
		},
		"PR-ESG": {
			name: "Lic. Ernesto Sandoval Gutierrez",
			from: "Asesor Jurídico",
			speciality: "Derecho Familiar, Derecho Mercantil",
			phone: [["686", "161", "1342"]],
			email: "bufete1695@gmail.com",
		},
	};

	const openWhatsappChat = () => {
		const data = profiles[profile_code];
		window.open(`https://wa.me/521${data.phone[0][0]}${data.phone[0][1]}${data.phone[0][2]}`, "_blank");
	};

	const openGoogleMaps = () => {
		window.open(
			"https://www.google.com/maps/place/Abogados+Penalistas+-+PROLITIGIO+S.C./@32.6614374,-115.4803656,20z/data=!4m14!1m7!3m6!1s0x80d77114d035ca0d:0x795d0c19fc7e1ed9!2sAbogados+Penalistas+-+PROLITIGIO+S.C.!8m2!3d32.6614338!4d-115.4802514!16s%2Fg%2F11h_vxd_n9!3m5!1s0x80d77114d035ca0d:0x795d0c19fc7e1ed9!8m2!3d32.6614338!4d-115.4802514!16s%2Fg%2F11h_vxd_n9?entry=ttu&g_ep=EgoyMDI2MDQwOC4wIKXMDSoASAFQAw%3D%3D",
			"_blank",
		);
	};

	const newSection = (icon, title, content) => {
		return (
			<>
				<div className="d-flex flex-column">
					<div className="d-flex flex-row">
						<div className="row-icon">{icon}</div>
						<div className="row-title">{title}</div>
					</div>
					<div className="d-flex flex-row">
						<div className="col-1"></div>
						<div className="flex-grow-1">{content}</div>
					</div>
				</div>
				<hr />
			</>
		);
	};

	const getContactCard = (profile) => {
		if (profiles[profile] === undefined) {
			return <></>;
		}
		const data = profiles[profile];
		return (
			<>
				<div className="d-flex flex-column row-profile" style={{ marginBottom: "20px" }}>
					<div className="profile-name">{data.name}</div>
				</div>
				<hr />
				<div className="profile-from">
					<FaUniversity style={{ color: "gray", marginRight: "10px", marginBottom: "5px", width: "25px", height: "25px" }} />
					<span>{data.from}</span>
				</div>
				<hr />
				<div className="profile-speciality">
					<FaBalanceScale style={{ color: "gray", marginRight: "10px", marginBottom: "5px", width: "25px", height: "25px" }} />
					<span>{data.speciality}</span>
				</div>
				<hr />
				{newSection(
					<FaAddressCard style={{ marginTop: "5px", width: "25px", height: "25px" }} />,
					"Contacto",
					<div className="d-flex flex-column row-profile">
						<div className="d-flex flex-column flex-lg-row align-items-start">
							{data.phone.map((phone, idx) => (
								<Button variant="link" href={`tel:${phone[0]}-${phone[1]}-${phone[2]}`} key={`ph-${idx}`}>
									<FaPhoneAlt
										className="profile-phone-icon"
										style={{ marginTop: "4px", marginRight: "10px", width: "18px", height: "18px" }}
									/>
									<span>{`(${phone[0]}) ${phone[1]}-${phone[2]}`}</span>
								</Button>
							))}
							{data.email !== "" ? (
								<Button className="profile-email" variant="link" href={`mailto:${data.email}`}>
									<FaEnvelope
										className="profile-email-icon"
										style={{ marginRight: "10px", width: "18px", height: "18px" }}
									/>
									<span>{data.email}</span>
								</Button>
							) : null}
						</div>
					</div>,
				)}
			</>
		);
	};

	return (
		<>
			<div className="page-title">Profesionales en Litigación Oral S.C.</div>
			<Container className="main-content card">
				<Row>
					<Col xs={12} style={{ padding: "0" }}>
						<Image src={logo_header} fluid />
					</Col>
				</Row>
				<Row className="bg-blue">
					<Col className="row-content" xs={11}>
						<h4>Abogados</h4>
						<p className="text-justify" style={{ opacity: 0.7 }}>
							Nuestro equipo esta integrado por Abogados apasionados del Derecho, especializados y con amplia experiencia en
							áreas del Derecho Penal, Fiscal, Civil, Familiar, entre otras.
						</p>
						<Button
							className="text-uppercase font-weight-bold text-blue m-2"
							variant="light"
							onClick={() => openWhatsappChat()}>
							<FaWhatsapp style={{ marginRight: "10px", marginBottom: "3px", width: "20px", height: "20px" }} />
							<span>Quiero una asesoría</span>
						</Button>
					</Col>
				</Row>
				<Row>
					<Col className="row-content" xs={11}>
						{getContactCard(profile_code)}
						{newSection(
							<FaMapMarkerAlt style={{ marginTop: "5px", width: "25px", height: "25px" }} />,
							"Ubicación",
							<div className="row-location">
								<span>Sebastián Lerdo de Tejada 368 interior 2</span>
								<span>Colonia segunda sección, Mexicali BC</span>
								<span>México</span>
								<Button
									style={{ marginTop: "20px", marginLeft: "-14px" }}
									className="text-uppercase"
									variant="light"
									onClick={() => openGoogleMaps()}>
									<FaMapMarkedAlt style={{ marginRight: "10px", marginBottom: "5px", width: "20px", height: "20px" }} />
									<span>Mostrar Mapa</span>
								</Button>
							</div>,
						)}
					</Col>
				</Row>
			</Container>
		</>
	);
};

export default QRCodeCards;
